import { initializeApp, getApps } from 'firebase/app';
import { getRemoteConfig, fetchAndActivate, getBoolean } from 'firebase/remote-config';
import store from '@/store';

/**
 * Obtiene la configuración de Firebase adaptada al entorno correcto (QA vs PROD)
 * según las variables de entorno inyectadas en el build de CircleCI (.env.qa / .env.production).
 */
export const getFirebaseConfig = () => {
  const env = process.env.VUE_APP_ENV || process.env.NODE_ENV || 'qa';
  const isProd = env === 'production' || process.env.VUE_APP_FIREBASE_PROJECT_ID === 'remsys-landing-site-prod';

  const projectId = process.env.VUE_APP_FIREBASE_PROJECT_ID || (isProd ? 'remsys-landing-site-prod' : 'remsys-landing-site-qa');
  const authDomain = process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || `${projectId}.firebaseapp.com`;
  const storageBucket = process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || `${projectId}.appspot.com`;

  return {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY || "AIzaSyDummyApiKeyForRemoteConfigInit",
    authDomain,
    projectId,
    storageBucket,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || "1234567890",
    appId: process.env.VUE_APP_FIREBASE_APP_ID || (isProd ? "1:1234567890:web:remsysprod" : "1:1234567890:web:remsysqa"),
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID || (isProd ? "G-PRODMEASUREMENTID" : "G-QAMEASUREMENTID")
  };
};

/**
 * Inicializa Firebase Remote Config, establece el valor predeterminado (true),
 * consulta el backend y actualiza el estado reactivo en Vuex Store.
 */
export async function initRemoteConfig() {
  try {
    const config = getFirebaseConfig();
    const app = !getApps().length ? initializeApp(config) : getApps()[0];
    const remoteConfig = getRemoteConfig(app);

    // Ajustar intervalo mínimo de fetch: en QA 10 segundos para pruebas inmediatas, en PROD 1 hora
    const isProd = (process.env.VUE_APP_ENV === 'production' || process.env.NODE_ENV === 'production');
    remoteConfig.settings = {
      minimumFetchIntervalMillis: isProd ? 3600000 : 10000,
      fetchTimeoutMillis: 15000
    };

    // 1. Establecer valores predeterminados en la app (según especificación, PROPERTIES_SEARCH = true)
    remoteConfig.defaultConfig = {
      PROPERTIES_SEARCH: true
    };

    // 2. Intentar obtener y activar la configuración remota desde Firebase
    await fetchAndActivate(remoteConfig);

    // 3. Leer la configuración PROPERTIES_SEARCH
    const propertiesSearchEnabled = getBoolean(remoteConfig, 'PROPERTIES_SEARCH');
    // eslint-disable-next-line no-console
    console.log(`[RemoteConfig] Proyecto: ${config.projectId} | PROPERTIES_SEARCH:`, propertiesSearchEnabled);

    // 4. Actualizar estado reactivo global
    store.commit('SET_PROPERTIES_SEARCH_ENABLED', propertiesSearchEnabled);

    return propertiesSearchEnabled;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[RemoteConfig] Aviso al cargar Remote Config (usando valor predeterminado true):', error.message || error);
    // En caso de error de red o falta de API key local, se preserva el comportamiento por defecto (true)
    store.commit('SET_PROPERTIES_SEARCH_ENABLED', true);
    return true;
  }
}
